import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight, CalendarToday } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import { format, parseISO } from 'date-fns';

const DateSelector = ({
  datePeriods = [],
  currentPeriodIndex = 0,
  onPeriodChange,
  onNextPeriod,
  selectedDate,
  onDateChange,
  loading = false,
}) => {
  const [pickerOpen, setPickerOpen] = React.useState(false);

  const getDateRange = () => {
    if (
      datePeriods.length === 0 ||
      currentPeriodIndex < 0 ||
      currentPeriodIndex >= datePeriods.length
    ) {
      return 'Cargando...';
    }
    const currentPeriod = datePeriods[currentPeriodIndex];
    return currentPeriod
      ? `${format(parseISO(currentPeriod.start_date), 'dd/MM/yyyy')} - ${format(parseISO(currentPeriod.end_date), 'dd/MM/yyyy')}`
      : 'Cargando...';
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
      <IconButton
        onClick={() => onPeriodChange(Math.max(currentPeriodIndex - 1, 0))}
        disabled={loading || currentPeriodIndex === 0}
      >
        <ChevronLeft />
      </IconButton>
      <IconButton
        onClick={() => setPickerOpen(true)}
        disabled={loading}
        sx={{ ml: 1 }}
      >
        <CalendarToday />
      </IconButton>
      <Typography variant="body1" sx={{ mx: 2, minWidth: 200, textAlign: 'center' }}>
        {getDateRange()}
      </Typography>
      <IconButton
        onClick={() => {
          if (currentPeriodIndex < datePeriods.length - 1) {
            onPeriodChange(Math.min(currentPeriodIndex + 1, datePeriods.length - 1));
            return;
          }
          onNextPeriod?.();
        }}
        disabled={loading || datePeriods.length === 0}
      >
        <ChevronRight />
      </IconButton>
      <DatePicker
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        value={selectedDate}
        onChange={(date) => {
          onDateChange(date);
          setPickerOpen(false);
        }}
        renderInput={(params) => <TextField {...params} sx={{ display: 'none' }} />}
      />
    </Box>
  );
};

export default DateSelector;
